<template>
  <div class="organization">
    <div class="card-header bg-default">
      {{ organization.companyName }}
    </div>
    <ul class="list-group list-group-flush">
      <li class="list-group-item">
        <span class="badge badge-success" v-if="organization.oneWayTrips">
          One Way Trips
        </span>
        <span class="badge badge-success" v-if="organization.carPooling">
          Car Pooling
        </span>
        <span class="badge badge-success" v-if="organization.externalFinanceCodes">
          External Finance Codes
        </span>
        <span class="badge badge-success" v-if="organization.useCredits">
          Credits
        </span>
        <span class="badge badge-success" v-if="organization.useReservationPromos">
          Reservation Promos
        </span>
        <span class="badge badge-success" v-if="organization.incompleteReminders">
          Incomplete Application Reminders
        </span>
        <span class="badge badge-success" v-if="organization.useFinanceExtras">
          Finance Code Bookings Allow Extras
        </span>
        <span class="badge badge-success" v-if="organization.useExternalAuth">
          External Authentication
        </span>
      </li>
      <li class="list-group-item">
        <span class="fa fa-fw fa-map-marker-alt"></span> {{ organization.companyAddress }},
        {{ organization.companySuburb }} {{ organization.companyPostcode }}
        {{ organization.companyState }} {{ organization.companyCountry }}
      </li>
      <li class="list-group-item">
        <span class="fa fa-fw fa-phone"></span>
        <a :href="`tel:${organization.companyPhone}`">
          {{ organization.companyPhone }}
        </a>
      </li>
      <li class="list-group-item">
        <span class="fa fa-fw fa-envelope"></span>
        <a :href="`mailto:${organization.companyEmail}`">
          {{ organization.companyEmail }}
        </a>
      </li>
      <li class="list-group-item">
        <span class="fa fa-fw fa-desktop"></span>
        <a :href="organization.homePage" target="_blank">
          {{ organization.homePage }}
        </a>
      </li>
    </ul>
    <div class="card-body">
      <div class="row">
        <div class="col-sm mb-3">
          <h5 class="card-title"><span class="fa fa-fw fa-calendar-alt"></span>Booking Times</h5>
          <p class="card-text">
            {{ organization.minimumBooking }} hours - {{ organization.maximumBooking }} days
          </p>
        </div>
        <div class="col-sm mb-3">
          <h5 class="card-title"><span class="fa fa-fw fa-star"></span>Weekend Rates</h5>
          <p class="card-text">
            Fri {{ organization.weekendRateStart | time_format }} - Mon {{ organization.weekendRateEnd | time_format }}
          </p>
        </div>
        <div class="col-sm">
          <h5 class="card-title"><span class="fa fa-fw fa-moon"></span>Overnight Rates</h5>
          <p class="card-text">
            {{ organization.overnightRateStart | time_format }} - {{ organization.overnightRateEnd | time_format }}
          </p>
        </div>
      </div>
    </div>
    <div class="card-footer text-right">
      <router-link class="btn btn-primary btn-sm"
        :to="{ path: `/contracts/organisations/edit/${organization.uuid}` }">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Organization',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    carImage () {
      return 'https://techcar-dev.s3.amazonaws.com/' +
      this.organization.OrganizationLogo.objectKey
    }
  },
  data () {
    return {
      organization: {
        OrganizationLogo: {
          objectKey: ''
        }
      }
    }
  },
  mounted () {
    this.organization = this.object
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/Organization.vue